var path = '/templates/projects.settings/initialization/item_list_price.html';
var html = "<div id=projectSettingsBase><h1 class=config-title>{{ 'projectsSettings.initialization.itemListPrice.shouhin_risuto_kakaku' | translate }}</h1><zc-session-sampler project=project title=\"{{ 'projectsSettings.initialization.itemListPrice.shouhin_risuto_kakaku' | translate }}\" indicator=item_list_price_found_rate></zc-session-sampler><p class=config-lead>{{ 'projectsSettings.initialization.itemListPrice.okyakusama_ga_mite' | translate }}</p><zc-item-list-price-editor project-id=project.id></zc-item-list-price-editor></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.settings/initialization/item_list_price.html
// module id = 1493
// module chunks = 0